<template>
     <div class="h-screen lg:block border-r z-30 bg-gray-100 overflow-y-auto" id="main-nav">

        <div class="w-full h-20 border-b flex px-4 items-center mb-3">
            <a href="/" class="flex" style="align-items: center;">
                <img class="w-12" src="@/assets/img/logo.png" alt="Logo">
                <h6 class="text-5xl mb-0 font-serif font-extrabold h-fit" style="color: #7D8600;">HUET</h6>
            </a>
        </div>

        <div class="flex flex-col gap-2 md:gap-6">
            <div class="flex flex-col gap-1 md:gap-2">
                <h4 class="pl-[32px] pr-[16px] w-full border-l-4 min-w-[171px] font-semibold text-lg text-prime-color">Quản lý chung</h4>
                <div 
                    v-for="(item, index) in overallMenu" :key="index" 
                    class="px-[16px] py-[16px] md:py-3 w-full flex gap-1 items-center h-10 hover:bg-gray-200 border-l-4 min-w-[171px]"
                    :class="currentPage == item.path ? 'text-prime-color bg-gray-200 border-prime-color' : 'text-gray-600 cursor-pointer border-transparent'"
                    @click="redirect(item)"
                >
                    <i class='pl-[16px] md:pl-1 xl:pl-3 bx bx-sm' :class="item.icon"></i>
                    <span class="text-xl">{{ item.name }}</span>
                </div>
            </div>
            <hr>
            <div class="flex flex-col gap-1 md:gap-2 mb-4">
                <h4 class="pl-[32px] pr-[16px] w-full border-l-4 min-w-[171px] font-semibold text-lg text-prime-color">Quản lý nội dung</h4>
                <div 
                    v-for="(item, index) in dataMenu" :key="index" 
                    class="px-[16px] py-[16px] md:py-3 w-full flex gap-1 items-center h-10 hover:bg-gray-200 border-l-4 min-w-[171px]"
                    :class="currentPage == item.path ? 'text-prime-color bg-gray-200 border-prime-color' : 'text-gray-600 cursor-pointer border-transparent'"
                    @click="redirect(item)"
                >
                    <i class='pl-[16px] md:pl-1 xl:pl-3 bx bx-sm' :class="item.icon"></i>
                    <span class="text-xl">{{ item.name }}</span>
                </div>
            </div>
        </div>
    </div>
</template>
    
<script>
import { mapActions } from 'vuex'
export default {
    name: 'Sidebar',
    data(){
        return {
            dataMenu: [
                {name: 'Người dùng', icon: 'bxs-user-account', path: 'user', isMaintain: false},
                {name: 'Chương trình đào tạo', icon: 'bxs-book-bookmark', path: 'course', isMaintain: false},
                {name: 'Tin tức', icon: 'bxs-news', path: 'news', isMaintain: false},
                {name: 'Tuyển dụng', icon: 'bxs-user-detail', path: 'recruitment', isMaintain: false},
                {name: 'Hợp tác', icon: 'bx-trip', path: 'cooperation', isMaintain: false},
                {name: 'Giảng viên', icon: 'bx-user-circle', path: 'staff', isMaintain: false},
            ],
            overallMenu: [
                {name: 'Tổng quan', icon: 'bxs-dashboard', path: 'dashboard', isMaintain: false},
                {name: 'QL Trang chủ', icon: 'bxs-home', parent: 'manage-web', path: 'manage-home', isMaintain: false},
                {name: 'QL Giới thiệu', icon: 'bxs-message-edit', parent: 'manage-web', path: 'manage-about', isMaintain: false},
                {name: 'QL Tuyển sinh (x)', icon: 'bxs-user-plus', parent: 'manage-web', path: 'manage-admission', isMaintain: true},
                {name: 'QL Đào tạo', icon: 'bxs-book-reader', parent: 'manage-web', path: 'manage-training', isMaintain: false},
                {name: 'QL Sinh viên (x)', icon: 'bxs-user-pin', parent: 'manage-web', path: 'manage-student-life', isMaintain: true},
                {name: 'QL Hợp tác (x)', icon: 'bxs-buildings', parent: 'manage-web', path: 'manage-cooperation', isMaintain: true},
                {name: 'QL Tuyển dụng', icon: 'bxs-user-badge', parent: 'manage-web', path: 'manage-recruitment', isMaintain: false},
                {name: 'Cấu hình Website', icon: 'bxs-cog', parent: 'manage-web', path: 'manage-config', isMaintain: false},
                {name: 'Test upload ảnh', icon: 'bxs-image-add', path: 'manage-upload', isMaintain: false},
            ]
        }
    },
    methods: {
        ...mapActions('admin', ['closeSidebar']),
        redirect(item) {
            this.closeSidebar()
            if (item.isMaintain) {
                this.$swal.fire(
                    'Đã xây dựng form<br>Chỉ cần cấu hình!',
                    '',
                    'success'
                )
            } else if (this.currentPage != item.path) {
                if (item.parent) {
                    this.$router.push({name: 'admin.' + item.parent + '.' + item.path})
                } else {
                    this.$router.push({name: 'admin.' + item.path})
                }
            }
        }
    },
    computed: {
        currentPage() {
            return this.$route.name.split('.')[this.$route.name.split('.').length - 1]
        }
    },
}
</script>
    
<style lang="scss" scoped>

</style>
    